(function () {
  'use strict';
  if (window.__pdpLoaded) return;
  window.__pdpLoaded = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Galería ---------- */
  function initGallery(root) {
    var slider = $('[data-pdp-slider]', root);
    if (!slider) return;
    var slides = $$('.pdp-gallery-slide', slider);
    var thumbs = $$('[data-pdp-thumb]', root);
    var thumbsRow = $('[data-pdp-thumbs]', root);
    var prev = $('[data-pdp-prev]', root);
    var next = $('[data-pdp-next]', root);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) {
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          if (thumbsRow) {
            var left = t.offsetLeft - (thumbsRow.clientWidth - t.clientWidth) / 2;
            thumbsRow.scrollTo({ left: left, behavior: 'smooth' });
          }
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i) {
      if (i < 0 || i >= slides.length) return;
      slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-pdp-thumb'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(slider.scrollLeft / slider.clientWidth);
        if (i !== current) setActive(i);
        ticking = false;
      });
    }, { passive: true });

    setActive(0);
  }

  /* ---------- Bundles + precios ---------- */
  function initBundles(root) {
    var dataEl = $('[data-pdp-variants]', root);
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });

    var tiers = $$('[data-pdp-tier]', root);
    var input = $('[data-pdp-variant-input]', root);
    var addonsBox = $('.pdp-addons', root);

    /* Los complementos forman parte del recuadro del bundle elegido */
    function setupAddons() {
      /* Complementos en un bloque único bajo los packs (posición original). Quitar este return para pegarlos otra vez dentro de cada pack. */
      return;
      if (!addonsBox || !tiers.length) return;
      tiers.forEach(function (t, i) {
        var p = i === 0 ? addonsBox : addonsBox.cloneNode(true);
        t.classList.add('pdp-qb--joined');
        t.insertAdjacentElement('afterend', p);
        p.classList.add('pdp-addons--attached');
      });
    }

    function render(v) {
      $$('[data-pdp-price]', root).forEach(function (el) { el.textContent = v.price; });
      $$('[data-pdp-compare]', root).forEach(function (el) {
        if (v.compare) { el.textContent = v.compare; el.hidden = false; } else { el.hidden = true; }
      });
      $$('[data-pdp-badge]', root).forEach(function (el) { el.hidden = !v.pct; });
      $$('[data-pdp-pct]', root).forEach(function (el) { el.textContent = v.pct; });
      $$('[data-pdp-atc]', root).forEach(function (btn) { btn.disabled = !v.available; });
    }

    setupAddons();

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        var id = parseInt(tier.getAttribute('data-variant-id'), 10);
        var v = byId[id];
        if (!v) return;
        tiers.forEach(function (t) { t.setAttribute('aria-checked', t === tier ? 'true' : 'false'); });
        if (input) input.value = id;
        render(v);
      });
      tier.addEventListener('keydown', function (e) {
        var i = tiers.indexOf(tier);
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); (tiers[i + 1] || tiers[0]).focus(); (tiers[i + 1] || tiers[0]).click(); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); (tiers[i - 1] || tiers[tiers.length - 1]).focus(); (tiers[i - 1] || tiers[tiers.length - 1]).click(); }
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral de Dawn) ---------- */
  function initAddToCart(root) {
    var form = $('[data-pdp-form]', root) || $('form[action*="/cart/add"]', root);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var buttons = $$('.pdp-atc', root);
      buttons.forEach(function (b) { b.disabled = true; });

      var drawer = document.querySelector('cart-drawer');
      var idInput = form.querySelector('[data-pdp-variant-input]');
      var keepId = null;
      if (idInput && idInput.getAttribute('data-plain')) { keepId = idInput.value; idInput.value = idInput.getAttribute('data-plain'); }
      var fd = new FormData(form);
      if (keepId !== null) idInput.value = keepId;
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', body: fd, headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) return data;
          var extras = [];
          $$('[data-pdp-addon-input]:checked', root).forEach(function (i) {
            var vid = parseInt(i.closest('[data-pdp-addon]').getAttribute('data-variant-id'), 10);
            if (extras.indexOf(vid) < 0) extras.push(vid);
          });
          var autoEl = $('[data-pdp-autoprotect]', root);
          var autoId = 0;
          try { if (autoEl && !window.__pdpSkipProtect && !window.sessionStorage.getItem('pdpNoProtect')) autoId = parseInt(autoEl.getAttribute('data-pdp-autoprotect'), 10) || 0; } catch (e) { if (autoEl && !window.__pdpSkipProtect) autoId = parseInt(autoEl.getAttribute('data-pdp-autoprotect'), 10) || 0; }
          window.__pdpSkipProtect = false;
          var check = autoId
            ? fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { if (!c.items.some(function (i) { return i.variant_id === autoId; }) && extras.indexOf(autoId) < 0) extras.push(autoId); }).catch(function () {})
            : Promise.resolve();
          return check.then(function () {
          if (!extras.length) return data;
          var ids = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: extras.map(function (id) { return { id: id, quantity: 1 }; }), sections: ids, sections_url: window.location.pathname })
          }).then(function (r) { return r.json(); }).then(function (d2) {
            if (d2.status) return data;
            $$('[data-pdp-addon-input]:checked', root).forEach(function (i) { i.checked = false; i.closest('[data-pdp-addon]').classList.remove('is-checked'); });
            return d2;
          });
          });
        })
        .then(function (data) {
          if (data.status) {
            buttons.forEach(function (b) { b.disabled = false; });
            window.alert(data.description || 'No se pudo añadir al carrito.');
            return;
          }
          var main = $('[data-pdp-atc]', root);
          var label = main ? $('[data-pdp-atc-label]', main) : null;
          var original = label ? label.textContent : '';
          if (label) label.textContent = '✓ Añadido';
          if (main) main.classList.add('pdp-atc--success');
          setTimeout(function () {
            if (drawer && data.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            }
            if (label) label.textContent = original;
            if (main) main.classList.remove('pdp-atc--success');
            buttons.forEach(function (b) { b.disabled = false; });
          }, 400);
        })
        .catch(function () {
          buttons.forEach(function (b) { b.disabled = false; });
          window.alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
        });
    });
  }

  /* ---------- Texto del enlace de Shopify «More payment options» ---------- */
  function initMoreOptions(root) {
    var box = $('[data-more-label]', root);
    if (!box) return;
    var label = box.getAttribute('data-more-label');
    function apply() {
      var link = box.querySelector('.shopify-payment-button__more-options');
      if (link && link.textContent.trim() !== label) link.textContent = label;
    }
    apply();
    new MutationObserver(apply).observe(box, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- Barra fija ---------- */
  function initSticky(root) {
    var bar = $('[data-pdp-sticky]', root);
    var buy = $('[data-pdp-buy]', root);
    if (!bar || !buy) return;
    document.body.classList.add('pdp-has-sticky');
    var ticking = false;

    function update() {
      var rect = buy.getBoundingClientRect();
      var footer = document.querySelector('.footer, footer');
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = rect.bottom < 0 && !nearFooter;
      bar.setAttribute('data-visible', show ? 'true' : 'false');
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = $('.pdp-atc', bar);
      if (btn) btn.tabIndex = show ? 0 : -1;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    $$('[data-pdp-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-pdp-faq-item]');
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  /* ---------- Entradas + anillos ---------- */
  function initReveal() {
    var els = $$('.pdp-reveal');
    var counts = new Map();
    els.forEach(function (el) {
      var i = counts.get(el.parentElement) || 0;
      el.style.setProperty('--pdp-i', i);
      counts.set(el.parentElement, i + 1);
    });
    var rings = $$('[data-pdp-ring]');
    var targets = els.concat(rings);
    if (!targets.length) return;

    function show(el) {
      el.classList.add('is-visible');
      if (el.hasAttribute('data-pdp-ring')) {
        var bar = $('.pdp-ring__bar', el);
        var pct = parseFloat(el.getAttribute('data-pdp-ring')) || 0;
        var len = 2 * Math.PI * 45;
        if (bar) bar.style.strokeDashoffset = String(len * (1 - pct / 100));
      }
    }

    if (!('IntersectionObserver' in window)) { targets.forEach(show); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carrito lateral: cupón y upsell ---------- */
  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && data && data.sections) {
      if (data.item_count === 0) drawer.classList.add('is-empty'); else drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    }
  }

  function initDrawerExtras() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('[data-pdp-discount-form]')) return;
      e.preventDefault();
      var code = (f.querySelector('input[name="discount"]') || {}).value;
      if (!code) return;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var msg = f.querySelector('[data-pdp-discount-msg]');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code.trim(), sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var applied = (data.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.trim().toLowerCase() && d.applicable; });
          if (!applied && msg) { msg.textContent = 'Este código no es válido para tu carrito.'; msg.hidden = false; return; }
          refreshDrawer(data);
        })
        .catch(function () { if (msg) { msg.textContent = 'No se pudo aplicar el código.'; msg.hidden = false; } });
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pdp-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest('[data-pdp-upsell]');
      var select = card ? card.querySelector('select') : null;
      var id = select ? select.value : btn.getAttribute('data-variant-id');
      var qv = card ? card.querySelector('[data-pdp-qty-val]') : null;
      var qty = qv ? Math.max(1, parseInt(qv.textContent, 10) || 1) : 1;
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty }], sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { refreshDrawer(data); })
        .finally(function () { btn.disabled = false; });
    });

    // Barra de regalos: pasar del pack 1+1 al 2+1 sin salir del carrito
    document.addEventListener('click', function (e) {
      var up = e.target.closest && e.target.closest('[data-pdp-upgrade]');
      if (!up) return;
      e.preventDefault();
      if (up.disabled) return;
      up.disabled = true;
      var key = up.getAttribute('data-key');
      var qty = parseInt(up.getAttribute('data-qty'), 10) || 1;
      var to = parseInt(up.getAttribute('data-to'), 10);
      var hdr = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch('/cart/change.js', { method: 'POST', headers: hdr, body: JSON.stringify({ id: key, quantity: qty - 1 }) })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: hdr, body: JSON.stringify({ items: [{ id: to, quantity: 1, properties: { '_mejora_desde_carrito': 'Sí' } }], sections: drawerSectionIds(), sections_url: window.location.pathname }) });
        })
        .then(function (r) { return r.json(); })
        .then(function (data) { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { data.item_count = c.item_count; refreshDrawer(data); }); })
        .catch(function () { up.disabled = false; });
    });
  }

  /* ---------- Protección de envío (opcional, el cliente la activa) ---------- */
  function drawerSectionIds() {
    var d = document.querySelector('cart-drawer');
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }
  function setProtection(variantId, on) {
    var url = on ? '/cart/add.js' : '/cart/change.js';
    var body = on
      ? { items: [{ id: variantId, quantity: 1 }], sections: drawerSectionIds(), sections_url: window.location.pathname }
      : { id: String(variantId), quantity: 0, sections: drawerSectionIds(), sections_url: window.location.pathname };
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (on && data.sections) {
          // /cart/add.js no devuelve item_count: se consulta para mantener el estado del carrito
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { data.item_count = c.item_count; refreshDrawer(data); });
        }
        refreshDrawer(data);
      });
  }
  /* ---------- Ebook de regalo con los packs ---------- */
  function initEbookGift() {
    var busy = false, tries = {};
    function post(url, body) {
      body.sections = drawerSectionIds(); body.sections_url = window.location.pathname;
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (data) { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { data.item_count = c.item_count; refreshDrawer(data); }); });
    }
    function check() {
      if (busy) return;
      var add = document.querySelector('[data-pdp-gift-add]');
      var rem = document.querySelector('[data-pdp-gift-remove]');
      if (!add && !rem) return;
      var tag = add ? 'a' + add.getAttribute('data-variant-id') : 'r' + rem.getAttribute('data-key');
      tries[tag] = (tries[tag] || 0) + 1;
      if (tries[tag] > 3) return;
      busy = true;
      var p = add
        ? post('/cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: 1, properties: { _regalo: '1' } }] })
        : post('/cart/change.js', { id: rem.getAttribute('data-key'), quantity: 0 });
      p.finally(function () { setTimeout(function () { busy = false; check(); }, 300); });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(check).observe(drawer, { childList: true, subtree: true });
    check();
  }

  function initProtection() {
    document.addEventListener('change', function (e) {
      var box = e.target.closest && e.target.closest('[data-pdp-protect]');
      if (!box) return;
      box.disabled = true;
      setProtection(parseInt(box.getAttribute('data-variant-id'), 10), box.checked)
        .catch(function () { box.checked = !box.checked; box.disabled = false; });
    });
    // Si solo queda la protección en el carrito, se quita sola
    var busy = false;
    function cleanOrphan() {
      var o = document.querySelector('[data-pdp-protect-orphan]');
      if (!o || busy) return;
      busy = true;
      setProtection(parseInt(o.getAttribute('data-variant-id'), 10), false).finally(function () { busy = false; });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(cleanOrphan).observe(drawer, { childList: true, subtree: true });
    cleanOrphan();
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-pdp]').forEach(function (root) {
      initGallery(root);
      initBundles(root);
      initAddToCart(root);
      initMoreOptions(root);
      initSticky(root);
    });
    initFaq();
    initReveal();
    initDrawerExtras();
    initProtection();
    initEbookGift();
  });
})();

/* Regalo con candado: se desbloquea al elegir el pack indicado */
(function () {
  function sync(root, animate) {
    var sel = root.querySelector('[data-pdp-tier][aria-checked="true"]');
    var id = sel ? sel.getAttribute('data-variant-id') : '';
    var any = false;
    root.querySelectorAll('[data-pdp-gift-lock]').forEach(function (g) {
      var open = g.getAttribute('data-unlock-id') === id;
      if (open) any = true;
      var was = !g.classList.contains('is-locked');
      g.classList.toggle('is-locked', !open);
      if (open && !was && animate) {
        g.classList.remove('is-unlocking'); void g.offsetWidth; g.classList.add('is-unlocking');
      }
    });
    root.querySelectorAll('[data-pdp-gifts-accent]').forEach(function (a) {
      a.textContent = a.getAttribute(any ? 'data-unlocked' : 'data-locked');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pdp-tier]');
    if (!t) return;
    var root = t.closest('[data-pdp]');
    if (root) setTimeout(function () { sync(root, true); }, 0);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-pdp-tier]');
    if (!t) return;
    var root = t.closest('[data-pdp]');
    if (root) setTimeout(function () { sync(root, true); }, 0);
  });
  function init() { document.querySelectorAll('[data-pdp]').forEach(function (r) { sync(r, false); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Fecha de entrega: se calcula cada día a partir de hoy */
(function () {
  function addDays(d, n, business) {
    var r = new Date(d.getTime());
    if (!business) { r.setDate(r.getDate() + n); return r; }
    var left = n;
    while (left > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) left--; }
    return r;
  }
  function fmt(d, opts) {
    try { return d.toLocaleDateString('es-MX', opts); } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }
  function run() {
    document.querySelectorAll('[data-pdp-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 5;
      var max = parseInt(el.getAttribute('data-max'), 10) || 10;
      var biz = el.getAttribute('data-business') === 'true';
      var now = new Date();
      var a = addDays(now, min, biz), b = addDays(now, max, biz);
      var o = { weekday: 'short', day: 'numeric', month: 'short' };
      var tpl = el.getAttribute('data-template') || '';
      var txt = el.querySelector('[data-pdp-eta-text]');
      if (tpl && txt) txt.innerHTML = tpl.replace('[inicio]', fmt(a, o).replace('.', '')).replace('[fin]', fmt(b, o).replace('.', ''));
      var root = el.classList.contains('pdp-steps') ? el : (el.closest('[data-pdp]') || document);
      root.querySelectorAll('[data-pdp-eta-range]').forEach(function (s) {
        s.textContent = 'Entre el ' + fmt(a, { day: 'numeric', month: 'short' }).replace('.', '') + ' y el ' + fmt(b, { day: 'numeric', month: 'short' }).replace('.', '');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Reseña destacada: flechas (y paso automático solo si está activado) con deslizamiento */
(function () {
  function go(box, dir) {
    var slides = box.querySelectorAll('[data-pdp-mr-slide]');
    var dots = box.querySelectorAll('.pdp-mr__dot');
    if (slides.length < 2) return;
    var cur = 0;
    slides.forEach(function (s, i) { if (s.classList.contains('is-active')) cur = i; });
    var next = (cur + dir + slides.length) % slides.length;
    var out = slides[cur], inn = slides[next];
    box.classList.toggle('pdp-mr--back', dir < 0);
    inn.classList.add('no-anim'); inn.classList.remove('is-leaving'); void inn.offsetWidth; inn.classList.remove('no-anim');
    out.classList.remove('is-active'); out.classList.add('is-leaving'); out.setAttribute('aria-hidden', 'true');
    inn.classList.add('is-active'); inn.removeAttribute('aria-hidden');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
    setTimeout(function () { out.classList.add('no-anim'); out.classList.remove('is-leaving'); void out.offsetWidth; out.classList.remove('no-anim'); }, 600);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pdp-mr-go]');
    if (!b) return;
    var box = b.closest('[data-pdp-mr]');
    if (box) { box.__manual = true; go(box, parseInt(b.getAttribute('data-pdp-mr-go'), 10)); }
  });
  function init() {
    document.querySelectorAll('[data-pdp-mr]').forEach(function (box) {
      var secs = parseInt(box.getAttribute('data-autoplay'), 10) || 0;
      if (!secs || box.__auto) return;
      box.__auto = true;
      setInterval(function () { if (!document.hidden && !box.__manual) go(box, 1); }, secs * 1000);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Cinta de avisos: al tocarla en el móvil se pausa, al volver a tocar sigue */
document.addEventListener('touchstart', function (e) {
  var pc = e.target.closest && e.target.closest('.pc');
  document.querySelectorAll('.pc.is-paused').forEach(function (x) { if (x !== pc) x.classList.remove('is-paused'); });
  if (pc && !e.target.closest('a')) pc.classList.toggle('is-paused');
}, { passive: true });

/* Vídeos en bucle: los arranca al verse y, si el móvil bloquea la reproducción
   automática (ahorro de batería / datos), al primer toque en la página. */
(function () {
  function vids() { return document.querySelectorAll('video[autoplay][muted], video[autoplay]'); }
  function tryPlay(v) {
    if (!v || !v.paused) return;
    v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { asImage(v); });
    setTimeout(function () { if (v.paused && isVisible(v)) asImage(v); }, 2500);
  }
  var isSafari = /Apple/.test(navigator.vendor || '') && /Safari|iPhone|iPad/.test(navigator.userAgent);
  function isVisible(v) { var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.width > 0; }
  /* iPhone con ahorro de batería: Safari no deja reproducir vídeos solos, pero sí anima un MP4 puesto como imagen */
  function asImage(v) {
    if (!isSafari || v.dataset.pdpImg || !v.paused) return;
    var s = v.querySelector('source[type="video/mp4"]') || v.querySelector('source');
    var src = (s && s.src) || v.currentSrc || v.src;
    if (!src) return;
    v.dataset.pdpImg = '1';
    var r = v.getBoundingClientRect();
    var img = new Image();
    img.className = 'pdp-vimg';
    img.alt = v.getAttribute('aria-label') || '';
    if (r.width && r.height) img.style.aspectRatio = (r.width / r.height).toFixed(4);
    img.onload = function () { if (v.paused && v.parentNode) v.parentNode.replaceChild(img, v); };
    img.src = src;
  }
  function init() {
    var list = vids();
    if (!list.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) tryPlay(e.target); });
      }, { rootMargin: '200px 0px' });
      list.forEach(function (v) { io.observe(v); });
    } else {
      list.forEach(tryPlay);
    }
    function unlock() {
      vids().forEach(tryPlay);
      ['touchend', 'click', 'keydown'].forEach(function (t) { document.removeEventListener(t, unlock, true); });
    }
    ['touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, unlock, true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* Selector de cantidad de las sugerencias del carrito */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-pdp-qty-dec],[data-pdp-qty-inc]');
  if (!b) return;
  var box = b.closest('[data-pdp-qty]');
  var v = box && box.querySelector('[data-pdp-qty-val]');
  if (!v) return;
  var n = parseInt(v.textContent, 10) || 1;
  n = b.hasAttribute('data-pdp-qty-inc') ? Math.min(n + 1, 10) : Math.max(n - 1, 1);
  v.textContent = n;
});


/* Selector de cantidad de la ficha de producto */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-pdp-qty-step]');
  if (!b) return;
  var inp = b.parentNode.querySelector('[data-pdp-qty-input]');
  if (!inp) return;
  var n = (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-pdp-qty-step'), 10);
  inp.value = Math.max(1, Math.min(20, n));
});
document.addEventListener('change', function (e) {
  var inp = e.target.matches && e.target.matches('[data-pdp-qty-input]') ? e.target : null;
  if (inp) inp.value = Math.max(1, Math.min(20, parseInt(inp.value, 10) || 1));
});


/* Casillas de complementos junto a los bundles */
document.addEventListener('change', function (e) {
  var i = e.target.matches && e.target.matches('[data-pdp-addon-input]') ? e.target : null;
  if (!i) return;
  var row = i.closest('[data-pdp-addon]');
  if (!row) return;
  row.classList.toggle('is-checked', i.checked);
  var vid = row.getAttribute('data-variant-id');
  var scope = i.closest('[data-pdp]') || document;
  Array.prototype.slice.call(scope.querySelectorAll('[data-pdp-addon][data-variant-id="' + vid + '"]')).forEach(function (r) {
    var inp = r.querySelector('[data-pdp-addon-input]');
    if (inp && inp !== i) { inp.checked = i.checked; r.classList.toggle('is-checked', i.checked); }
  });
});
